import { getAccountActiveCount } from "@/api/accountCount";
import { useSidebarCountStore } from "@/store/pinia/sidebarCount";

/**
 * Updates account counts by calling the active account API and storing the data.
 * IMPORTANT: This function fetches counts that are INDEPENDENT of any filters
 * applied to employee/position/role/responsibility lists. The counts should
 * always reflect the total active counts regardless of current filter state.
 *
 * @param {string|number} account_id - The account ID
 * @returns {Promise<void>}
 */
export const updateAccountCounts = async (account_id) => {
  try {
    const { data: accountCounts } = await getAccountActiveCount(account_id);
    if (accountCounts) {
      const sidebarCountStore = useSidebarCountStore();
      sidebarCountStore.setAccountCounts(accountCounts);
    }
  } catch (error) {
    console.error("Error updating account counts:", error);
  }
};

/**
 * Updates account counts on login/account selection
 * This should be called after a user logs in and selects an account
 * @param {string|number} account_id - The account ID
 * @returns {Promise<void>}
 */
export const updateAccountCountsOnLogin = async (account_id) => {
  if (!account_id) {
    console.warn("No account ID provided for account count update");
    return;
  }

  await updateAccountCounts(account_id);
};
